import { FC, useMemo } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { TPartnerForm } from "@/features/rso/types/partnerForm";
import { InnerBox } from "@/components/elements/InnerBox";
import { Grid } from "@mui/material";
import { FormField } from "@/components/elements/FormField";
import { Input } from "@/components/elements/Input";
import { formatRSOId } from "@/utils/number";

type TBasicFormProps = {};

export const BasicForm: FC<TBasicFormProps> = () => {
  const methods = useFormContext<TPartnerForm>();
  const { control, setValue } = methods;
  const idValue = useWatch({ control, name: "id" });

  const formattedId = useMemo(() => {
    return formatRSOId(idValue);
  }, [idValue]);

  const handleLicenseNumberChange = (value: string) => {
    setValue("licenseNumber", value || "");
  };

  return (
    <InnerBox title="基本情報">
      <Grid container rowSpacing={2} columnSpacing={3}>
        <Grid item xs={6}>
          <FormField control={control} name="id" label="組織ID（自動生成）">
            <Input readonly placeholder="(保存後に自動生成されます)" nonControl value={formattedId} />
          </FormField>
        </Grid>
        <Grid item xs={6}></Grid>
        <Grid item xs={6}>
          <FormField control={control} name="name" label="登録支援機関名" required>
            <Input placeholder="入力してください" />
          </FormField>
        </Grid>
        <Grid item xs={6}>
          <FormField control={control} name="licenseNumber" label="登録番号">
            <Input placeholder="入力してください" onChange={(e) => handleLicenseNumberChange(e.target.value)} />
          </FormField>
        </Grid>
      </Grid>
    </InnerBox>
  );
};
